// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d1f44b1","453":"68812165","455":"5f04c7f3","977":"cb45eb69"}[chunkId] + ".chunk.js";
};